import { createFileRoute } from '@tanstack/react-router'
import { Package, Users, BarChart3, Zap } from 'lucide-react'
import styles from '../App.module.css'

const features = [
  {
    icon: Package,
    title: 'Каталог товаров',
    text: 'Управляйте тысячами SKU с гибкой системой атрибутов и категорий.'
  },
  {
    icon: Users,
    title: 'Поставщики',
    text: 'Ведите базу поставщиков, отслеживайте поставки и управляйте закупками.'
  },
  {
    icon: BarChart3,
    title: 'Аналитика',
    text: 'Понимайте, что продаётся, а что нет. Принимайте решения на основе данных.'
  },
  {
    icon: Zap,
    title: 'Импорт данных',
    text: 'Загружайте каталоги из Excel и CSV. Автоматическая обработка с помощью AI.'
  }
]

export const Route = createFileRoute('/')({
  component: HomePage
})

function HomePage() {
  return (
    <>
      <section className={styles.hero}>
        <div className={styles.container}>
          <h1>Управление розничной торговлей — просто</h1>
          <p className={styles.lead}>
            Каталог, поставщики, аналитика — всё в одном месте. Тандем помогает ритейлерам работать быстрее и
            эффективнее.
          </p>
          <a href='/register' className={styles.heroButton}>
            Начать бесплатно
          </a>
        </div>
      </section>

      <section className={styles.features}>
        <div className={styles.container}>
          <div className={styles.grid}>
            {features.map((f) => (
              <div key={f.title} className={styles.feature}>
                <f.icon size={32} strokeWidth={1.5} />
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
